import styled from 'styled-components';

import { colors, spacing } from '@hultafors/hultaforsgroup/helpers';

export const NewsLabelWrapper = styled.div`
  border-block-end: thin solid ${colors.HGGray1};
  padding-block: ${spacing.regular};
`;
